import React, { memo, useMemo } from "react";
import ReactHtmlParser from "react-html-parser";
import DOMPurify from "dompurify";
var HTMLRenderLocal = function (_a) {
    var html = _a.html;
    var parsedHtml = useMemo(function () {
        return ReactHtmlParser(DOMPurify.sanitize(html, {
            ADD_TAGS: ["iframe"],
            ADD_ATTR: [
                "allow",
                "allowfullscreen",
                "frameborder",
                "scrolling",
                "target",
            ],
        }));
    }, [html]);
    return React.createElement(React.Fragment, null, parsedHtml);
};
var HTMLRender = memo(HTMLRenderLocal);
export default HTMLRender;
